import { z } from 'zod'

/**
 * Кто вошёл. `GET /api/auth/me` отдаёт карточку сотрудника целиком, но сессии
 * нужно «кто я» и «что мне доступно». Лишние поля Zod отбрасывает — полный
 * человек приходит из команды.
 *
 * Ролей ровно две. Администратор ведёт команду и выходы; сотрудник — только
 * свой график. Права здесь только прячут недоступное: решает всё равно бэкенд,
 * и без него подмена роли в браузере ничего бы не открыла.
 */
export const SessionSchema = z
  .object({
    id: z.uuid(),
    name: z.string(),
    access_role: z.enum(['admin', 'employee']).default('employee'),
  })
  .transform((dto) => ({
    employeeId: dto.id,
    name: dto.name,
    isAdmin: dto.access_role === 'admin',
  }))

export type Session = z.infer<typeof SessionSchema>

export interface SignInInput {
  login: string
  password: string
}
